import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { cn } from "@omni/utils/styles";

import { splitPrice } from "@/utils/price.utils";

export const formatPriceForEcommerce = (price: number) => {
    const splitted = splitPrice(price);
    return `${splitted[0]},${splitted[1] === "00" ? "-" : splitted[1]}`;
};

const DeliveryItemBase = ({ children }: RequireChildrenFor<{}>) => {
    return (
        <div className={cn("tw:p-4 tw:not-last:border-b tw:border-grey-input")}>
            {children}
        </div>
    );
};

export { DeliveryItemBase };
